import styled from "styled-components";
import H1 from "../../../components/typography/H1";
import fontSize from "../../../theme/fonts/FontTheme";

const Wrapper = styled.div`
  padding: 0 20px;
  width: 100%;
  margin: clamp(5rem, (100 / 1920) * 100vw, 6.25rem) auto;
  box-sizing: border-box;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  gap: clamp(0.75rem, (16 / 1920) * 100vw, 1rem);

  h1 {
    margin-bottom: clamp(0.25rem, (8 / 1920) * 100vw, 0.5rem);
  }
  span {
    font-size: ${fontSize.s};
  }
`;

function SupportSection() {
  return (
    <Wrapper>
      <Container>
        <H1>HOURS OF SUPPORT</H1>
        <span>Monday to Friday</span>
        <span>09:00 am - 06:00 pm EST</span>
      </Container>
    </Wrapper>
  );
}

export default SupportSection;
